<h1 mat-dialog-title>TAM Meldung aus HIT f&uuml;r Meldung ID: {{ meldung?.meldung_id }}</h1>
<div mat-dialog-content>
    <pre>
        {{ jsn }}
    </pre>
</div>
